import { Card, Form, Row, Col, Button } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../../layout/default";
import Block from "../../../components/Block/Block";
import Swal from "sweetalert2";
import { useState, useEffect } from "react";
import api from "../../../../src/services/auth/api";
import { Link } from "react-router-dom";
import { Icon } from "../../../components";


// const baseURL = "http://127.0.0.1:8000/api/";

function ProductEdit() {
  const { id } = useParams(); // Get product ID from URL
  const [data, setData] = useState({
    title: "",
    description: "",
    product_id: id,
    unit_id: "",
    unit_quantity: "",
    discount: "",
  });
  const [loading, setLoading] = useState(true);
  const [validated, setValidated] = useState(false);
  const [UnitListData, setUnitListData] = useState([]);
  const navigate = useNavigate();

  // Handle input changes
  const handleInputs = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  // Fetch product data when the component loads
  const getProductData = () => {
    setLoading(true);
    api
      .get(`${process.env.REACT_APP_HOST}api/product-variant/${id}`)
      .then((response) => {
        debugger;
        if (response.data.success) {
          setData(response.data.data[0]); // Populate form fields with fetched data
        }
      })
      .catch((err) => {
        const message =
          err.response?.data?.errorMessages?.[0]?.message[0]?.message ||
          "Something went wrong!";
        Swal.fire({
          icon: "error",
          title: message,
          text: "Failed to fetch product data.",
        }).then(() => navigate("/shop/admin/product-variant-list"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // Fetch unit list data for dropdown
  const getUnitList = () => {
    api
      .get(`${process.env.REACT_APP_HOST}api/unit`)
      .then((response) => {
        setUnitListData(response.data);
      })
      .catch(() => {
        setUnitListData([]);
      });
  };

  // Call API to fetch product data and unit list
  useEffect(() => {
    getUnitList();
    if (id) {
      getProductData(); // Fetch product data when 'id' is available
    }
  }, [id]);

  // Update product data
  const postData = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      api
        .put(`${process.env.REACT_APP_HOST}api/product-variant/${id}`, data)
        .then((response) => {
          if (response.data.success) {
            Swal.fire({
              icon: "success",
              title: "Product updated successfully",
            }).then(() => navigate("/shop/admin/product-variant-list"));
          } else {
            updateError(response.data.content.error_description);
          }
        })
        .catch((err) => {
          if (err.response.data.validationErrors) {
            updateError(err.response.data.validationErrors);
          }
        });
    }
    setValidated(true);
  };

  const updateError = (message) => {
    let errorMessage;
    if (typeof message === "object") {
      errorMessage = Object.values(message).join("<br>");
    } else {
      errorMessage = message;
    }
    Swal.fire({
      icon: "error",
      title: "Save attempt was not successful",
      html: errorMessage,
    });
  };

  // Clear form data
  const clear = () => {
    setData({
      title: "",
      description: "",
      product_id: id,
      unit_id: "",
      unit_quantity: "",
      discount: "",
    });
  };

  return (
    <Layout title="Product Variant Edit">
      <Block.Head>
        <Block.HeadBetween>
          <Block.HeadContent>
            <Block.Title tag="h2">Product Variant Edit</Block.Title>
          </Block.HeadContent>
          <Block.HeadContent>
            <ul className="d-flex">
              <li>
                <Link
                  to="/shop/admin/product-variant-list"
                  className="btn btn-primary btn-md d-md-none"
                >
                  <Icon name="arrow-long-left" />
                  <span>Go to List</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/shop/admin/product-variant-list"
                  className="btn btn-primary d-none d-md-inline-flex"
                >
                  <Icon name="arrow-long-left" />
                  <span>Go to List</span>
                </Link>
              </li>
            </ul>
          </Block.HeadContent>
        </Block.HeadBetween>
      </Block.Head>

      <Block className="mt-n5">
        <Form noValidate validated={validated} onSubmit={postData}>
          <Row className="g-3">
            <Card>
              <Card.Body>
                {loading ? (
                  <h1 className="d-flex justify-content-center align-items-center">Loading...</h1>
                ) : (
                  <Row className="g-gs">
                    <Col lg="6">
                      <Form.Group className="form-group">
                        <Form.Label htmlFor="title">
                          Product Title<span className="text-danger">*</span>
                        </Form.Label>
                        <div className="form-control-wrap">
                          <Form.Control
                            id="title"
                            name="title"
                            value={data.title}
                            onChange={handleInputs}
                            type="text"
                            placeholder="Enter Product Variant Title"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Product Variant Name is required
                          </Form.Control.Feedback>
                        </div>
                      </Form.Group>
                    </Col>

                    <Col lg="6">
                      <Form.Group className="form-group">
                        <Form.Label htmlFor="description">
                          Product Variant Description
                          <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="form-control-wrap">
                          <Form.Control
                            id="description"
                            name="description"
                            value={data.description}
                            onChange={handleInputs}
                            type="text"
                            placeholder="Enter Product Variant Description"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            Product Description is required.
                          </Form.Control.Feedback>
                        </div>
                      </Form.Group>
                    </Col>

                    <Col lg="6">
                      <Form.Group className="form-group">
                        <Form.Label htmlFor="discount">
                          Discount<span className="text-danger">*</span>
                        </Form.Label>
                        <div className="form-control-wrap">
                          <Form.Control
                            id="discount"
                            type="number"
                            name="discount"
                            value={data.discount}
                            onChange={handleInputs}
                            placeholder="Enter Discount"
                            required
                            min="0"
                            step="0.01"
                          />
                        </div>
                      </Form.Group>
                    </Col>

                    <Col lg="6">
                      <Form.Group className="form-group">
                        <Form.Label>
                          Unit <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="form-control-wrap">
                          <Form.Select
                            name="unit_id"
                            value={data.unit_id}
                            onChange={handleInputs}
                            required
                            isInvalid={data.unit_id === undefined || data.unit_id === "0"}
                          >
                            <option value="0">Select Unit</option>
                            {UnitListData.map((unit) => (
                              <option key={unit.id} value={unit.id}>
                                {unit.title}
                              </option>
                            ))}
                          </Form.Select>
                        </div>
                      </Form.Group>
                    </Col>

                    <Col lg="6">
                      <Form.Group className="form-group">
                        <Form.Label htmlFor="unit_quantity">
                          Unit Quantity<span className="text-danger">*</span>
                        </Form.Label>
                        <div className="form-control-wrap">
                          <Form.Control
                            id="unit_quantity"
                            type="number"
                            name="unit_quantity"
                            value={data.unit_quantity}
                            onChange={handleInputs}
                            placeholder="Enter Unit Quantity"
                            required
                            min="1"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col lg="6">
                      <Form.Group className="form-group">
                        <Form.Label htmlFor="price">
                          Price<span className="text-danger">*</span>
                        </Form.Label>
                        <div className="form-control-wrap">
                          <Form.Control
                            id="price"
                            type="number"
                            name="price"
                            value={data.price}
                            onChange={handleInputs}
                            placeholder="Enter price"
                            required
                            min="0"
                            step="0.01"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                )}
              </Card.Body>
            </Card>
          </Row>

          <Row className="g-3">
            <div className="gap-col">
              <ul className="d-flex align-items-center justify-content-center gap g-3">
                <li>
                  <Button type="submit" variant="primary">
                    Save
                  </Button>
                </li>
                <li>
                  <Button type="button" variant="secondary" onClick={clear}>
                    Cancel
                  </Button>
                </li>
              </ul>
            </div>
          </Row>
        </Form>
      </Block>
    </Layout>
  );
}

export default ProductEdit;
